(() => {
    const recentSearchesToLoad = [];

    const heroes = document.querySelectorAll('.hero');

    let updateHeroSize = () => {
        let viewportHeight = window.innerHeight;

        heroes.forEach((hero) => {
            let size = 1;
            let classList = hero.classList;

            if (window.innerWidth > 992) {
                if (classList.contains('hero--small')) {
                    size = .5;
                } else if (classList.contains('hero--medium')) {
                    size = .75;
                }
            }
            
            if (size == 1) {
                return;
            }

            let heightInPx = (viewportHeight * size) + 'px';

            hero.style.maxHeight = heightInPx;
        });
    }

    heroes.forEach((hero) => {
        let currentSlide = 0;

        let timeout = null;
        const slides = hero.querySelectorAll('.hero--slides .hero--slide');

        const heroAction = hero.querySelector('.hero--action');

        const kickNextTimeout = () => {
            timeout = setTimeout(() => {
                toNextSlide();
            }, 5000);
        }

        const toNextSlide = (forceSlide = false, reverse = false) => {
            clearTimeout(timeout);

            let oldSlide = slides[currentSlide];

            oldSlide.classList.remove('--active');
            hero.querySelector('.hero--slider-dots .--active').classList.remove('--active');

            if (!forceSlide && forceSlide <= slides.length) {
                if (reverse) {
                    currentSlide = currentSlide-- < 1 ? slides.length - 1: currentSlide;
                } else {
                    currentSlide = currentSlide++ > slides.length ? slides.length : currentSlide % slides.length;
                }
            } else {
                currentSlide = forceSlide;
            }

            let newSlide = slides[currentSlide];

            hero.querySelector('.hero--slider-dots .hero--slider-dot[data-num="' + currentSlide + '"]').classList.add('--active');

            const titleEl = hero.querySelector('.hero--title');
            const locationEl = hero.querySelector('.hero--location');

            if (titleEl) {
                titleEl.innerText = newSlide.getAttribute('data-hotel-name');
            }
            
            if (locationEl) {
                locationEl.innerText = newSlide.getAttribute('data-hotel-location');
            }

            setTimeout(() => {
                slides[currentSlide].classList.add('--active');
                kickNextTimeout();
            }, 100);
        };



        if (slides.length > 1) {
            kickNextTimeout();

            let hammer = new Hammer(hero, {});
            hammer.on('swipeleft', (e) => {
                toNextSlide();
            });

            hammer.on('swiperight', (e) => {
                toNextSlide(false, true);
            });
        }

        slides.forEach((slide) => {
            if (slide.hasAttribute('data-lazy')) {
                let url = slide.getAttribute('data-lazy');
                slide.style.backgroundImage = `url('${url}')`;
            }
        });

        hero.querySelectorAll('.hero--slider-dot').forEach((dot) => {
            dot.addEventListener('click', () => {
                toNextSlide(dot.getAttribute('data-num'));
            });
        });

        if (heroAction) {
            const hotelId = heroAction.getAttribute('data-hotel');
            const checkoutUrl = heroAction.getAttribute('data-checkout-url');

            const actionTabs = heroAction.querySelectorAll('.hero--action-tab');

            const selectTab = (tabType) => {
                const targetTab = heroAction.querySelector(`#action-tab-${tabType}`);

                if (targetTab) {
                    heroAction.querySelector('.hero--action-tab.--active').classList.remove('--active');
                    targetTab.classList.add('--active');

                    const actionCards = heroAction.querySelectorAll('.hero--action-card-track');

                    actionCards.forEach((card) => {
                        card.classList.toggle('--show', card.getAttribute('data-show-for') == tabType);
                    });
                }
            }

            const sessionProvider = new roomstay.SessionProvider();
            sessionProvider.getAllSessions().then((sessions) => {
                const filteredSessions = sessions.filter((session) => {
                    if (session.basketRows.length && session.hotelID == hotelId) {
                        for (var i = 0; i < session.basketRows.length; i++) {
                            if (session.basketRows[i].isValid() && session.basketRows[i].endDate.isAfter()) {
                                return session;
                            }
                        }
                    }
                }).slice(0, 2);

                if (filteredSessions.length) {
                    filteredSessions.forEach((filteredSession) => {
                        const element = document.createElement('div');
                        element.classList.add('hero--action-card');
                        element.setAttribute('data-show-for', 'searches');

                        const row = filteredSession.basketRows[0];

                        console.log(row);

                        element.innerHTML = `
                        <div class="hero--action-card-image" style="background-image:url('${row.getRoom().images[0]}')"></div>
                        <div class="hero--action-card-content__recent-search">
                            <div class="title">${row.getRoom().name}</div>
                            <div class="description">
                                <div class="description__content">${filteredSession.basketRows[0].getRate().name}</div>
                            </div>
                            <div class="rsv">
                                <div class="rsv__date">
                                    ${row.startDate.format('ddd D')}, ${row.endDate.format('ddd D MMM')}
                                </div>
                                <div class="rsv__guest">
                                    ${row.adults} Adults, ${row.children} Children
                                </div>
                            </div>
                            
                            <a class="action-btn" href="${checkoutUrl}#/step/confirmation/?session=${filteredSession.id}">Book Now <i class="icon-right-small"></i></a>
                            
                        </div>
                        <a class="hero--action-card-link" href="${checkoutUrl}#/step/confirmation/?session=${filteredSession.id}"></a>
                    `;
                        hero.querySelector('.hero--action-card-track[data-show-for="searches"]').appendChild(element);
                    });

                    selectTab('searches');
                } else {
                    heroAction.querySelector('#action-tab-searches').style.display = 'none';
                    selectTab('explore');
                }

                dataLayer.push({
                    event: 'optimize.activateRecentSearches'
                });

                recentSearchesToLoad.push(() => {
                    setTimeout(() => {
                        heroAction.classList.add('is-ready');
                    }, 1500);
                });
            });
            
            actionTabs.forEach((actionTab) => {
                actionTab.addEventListener('click', () => {
                    selectTab(actionTab.getAttribute('data-tab'));
                });
            });
        }
    });

    updateHeroSize();

    window.addEventListener('resize', updateHeroSize);

    window.loadOptimizeRecentSearches = () => {
        recentSearchesToLoad.forEach((toRun) => {
            toRun();
        })
    }
})();
